export default "__VITE_ASSET__DdrR1X_e__"